module.exports = __webpack_public_path__ + "assets/images/29-5.jpg";